import React, {useState} from 'react'
import Development from '../../assets/development.jpg'
import Business from '../../assets/business.jpg'
import Status from '../../Components/Status/Status'
import CategoryIcon from '@mui/icons-material/Category';
import { baseUrl, path } from '../../constants'
import { Oval } from 'react-loader-spinner'
import { useQuery } from 'react-query'
import axios from 'axios'
import {useLocation, useParams} from 'react-router-dom'
import { toast } from 'react-toastify';
import {useNavigate} from 'react-router-dom'
import { api } from '../../api';

export default function SubCategories() {
    const { categoryId } = useParams()
    const { isLoading, error, data, refetch } = useQuery('fetchSubCategories', () =>
            axios(baseUrl + path.fetchSubCategories + '/' + categoryId, {
        })

    )
    const navigate = useNavigate()
    const [isDeleting, setIsDeleting] = useState(null)
    const {state} = useLocation()
    const {categoryName} = state
    const deleteRow = (row) => {
        let confirm = window.confirm('Are you sure you want to delete ' + row.name + '?')
        if(confirm){
            setIsDeleting(true)
            api.delete(path.deleteSubCategory, {
                data: {
                    id: row.id
                }
            }).then(response => { 
                let data = response.data
                if(data.success){
                    toast.success('Success!', {hideProgressBar: true})
                    refetch()
                }
            }).finally(() => setIsDeleting(false))
        }
    }

    const editSubCategory = (row) => {
        navigate("/add-sub-category/" + categoryId, { state: { subCategory: row} });
    }
    return [
    <Status title={`Sub-Categories for ${categoryName}`} action={{link: '/add-sub-category/' + categoryId, title: 'Add Sub-Category'}} />,
    isLoading ? (
        <div className='flex flex-col items-center gap-3'>
            <p className='text-black text-[15px]'>Loading data...</p>
            <Oval
                visible={true}
                height="30"
                width="30"
                color="#198754"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
        </div>
    ) : (
        <div className='flex flex-col gap-5 h-full w-full bg-white rounded-sm p-4'>
            <table className='w-full' cellPadding={10}>
                <thead>
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000068] bg-[#ededed]'>
                        <th align='left' className='p-2 text-[14px]'>Sub Category Name</th>
                        <th align='left' className='p-2 text-[14px]'>Action</th>
                    </tr>
                </thead>
                <tbody>
                {(data?.data?.subCategories || []).map(row => (
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000060]'>
                        <td className='p-2 text-[15px]'>{row.name}</td>
                        <td>
                        <div className='flex items-center h-full gap-2'>
                           
                            <button className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md' onClick={() => editSubCategory(row)}>
                                Edit
                            </button>
                            <button disabled={isDeleting == row.id} className='text-white px-4 py-2 bg-[#ff0000] text-xs font-bold rounded-md' onClick={() => deleteRow(row)}>
                                {isDeleting == row.id ? (
                                    <Oval
                                        visible={true}
                                        height="17"
                                        width="17"
                                        color="#ffffff"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                        strokeWidth={3}
                                    />
                                ) :  'Delete'}
                            </button>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
    ]
}
